//@ts-check
import cleanPath from './cleanPath';
/**
 * @type {import("./types").getFileNameType}
 */

export default function getFileName(path) {
  if (!path) return '';
  if (path.indexOf(':') !== -1) return path.substring(0, path.indexOf(':'));
  if (path.indexOf('.') === -1) return '';
  return cleanPath(path).split('/').pop();
}